// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-upload1[data-v-4e898558]{position:relative}.ls-upload1:hover .pre[data-v-4e898558]{display:block}.ls-upload1 .disabled[data-v-4e898558]{opacity:.3}.ls-upload1 .pre[data-v-4e898558]{position:absolute;left:0;bottom:100%;z-index:99;border:1px solid #333;display:none}.ls-upload1 .pre img[data-v-4e898558]{display:block;max-width:100%;max-width:500px}", ""]);
// Exports
module.exports = exports;
